<!-- the infoboard for pad and pc -->
<!-- 消息面板，里面包含了 Channel、Chat（Comment）、Sale info and so on -->
<template>
    <!-- 以下是有关 el-card 的使用说明
         1. 设置宽度和高度，
         2. 注意，样式 transform: scale(1) rotate(0deg); 是用来设置 card 的透明度的，这样保证它可以原色展示
         3. e-card 内部包含一个 div el-card__body 元素，用来布局内部的元素，通过 body-style 对其进行样式设计
    -->
    <!-- 这里要特别注意，要减去 infoboard body 上下 padding 合计有 30 的宽度，否则计算出来的总高度比 Carsousel 图片高度长 30，不协调 -->
    <div class="infoboard" style="transform: scale(1) rotate(0deg);" :style="`--height: ${height}px; --width: ${width}px;`" >
        <div class="body">
            <!-- 频道区域 -->
            <profile-section style="height:7%;" :avatar-size="32" :profile="profile" :location="e.location"></profile-section>
            <el-divider></el-divider>
            <div class="margin-bottom-2px"></div>
            <!-- 从 caption 开始，要实现隐藏滚动的特效，要注意的地方有
                 1. 布局上要注意的地方主要是 Safari，如果评论区超过了 scroll div 的宽度，那么下拉条将会被评论区隐藏，很丑。
                    现在实现的逻辑是，让整个评论区包裹在 scroll div 中，且 scroll div 的宽度比评论区的宽度多 15 个 px，而这 15
                    个 px 正好是 Safari scroll bar 需要的宽度。因此，设置 scroll div 的宽度为 320px，通过设置 el-row 的宽度
                    将评论区的宽度设置为 305 px。
                 2. scroll div 一定要设置 align=left，否则 el-row 的布局默认是 align right。
             -->
            <!-- 评论区域 -->
            <!-- 技巧：评论区域需要的高度是最多的，技巧是，将其他的组件布局不好了以后，剩余的空间给它就好了 -->
            <div id="comment-panel" class="comment-panel" align="left" style="height:68%;">
                <!-- caption：主题描述 -->
                <div class="inner-block">
                    <caption_ :url="profile.avatar"
                              :name="profile.name"
                              :code="profile.code"
                              :text="e.caption"
                              :timestamp="e.upload_ts"
                              :avatar-size="32">
                        <div class="margin-top-8px"></div>
                        <el-divider></el-divider>
                    </caption_>
                </div>
                <!-- comments area TODO 下面的这部分逻辑实际上也应该抽象到 Comment 组件中去-->
                <div class="inner-block comment-area" style="margin-top:20px">
                    <div align="center" style="padding-top:50px" v-if="loadingComments"><loading :text="null"></loading></div>
                    <comment ref="comment" :comments="comments" :avatar-size="32" v-if="hasComments"></comment>
                    <div style="display:inline-flex;align-items: center; margin: 20px 0 0 48px;" v-else-if="!loadingComments && !hasComments">
                        <div class="iconfont icon-sy-sofa" style="margin-right: 4px"></div>
                        <div style="color: #909399">还没有评论，赶紧来抢沙发吧</div>
                    </div>
                </div>
            </div>
            <div class="margin-bottom-2px"></div>
            <el-divider></el-divider>
            <!-- 喜欢区域 -->
            <div style="padding: 4px 0px 0px 0px; height:8%;">
                <!-- <favorite :e="e"></favorite>-->
                <phone-favorite :e="e"></phone-favorite>
            </div>
            <!-- slogan 和说明区域 -->
            <div style="padding: 10px 0px 8px 0px; height:8%;" align="center">
                <slogan></slogan>
                <div style="display:inline-flex;align-items: center;margin-top:4px">
                    <i class="iconfont icon-sy-laba" style="font-size:18px"></i>
                    <div style="margin-left: 4px;color:#210B61">1积分抵￥1 <span v-if="isShowWatermark">| 下载的视频图片不含火酷水印</span></div>
                </div>
            </div>
            <el-divider></el-divider>
            <!-- 评论输入区域 -->
            <div style="padding: 4px 0px 0px 0px; height:6%; ">
                <input_ ref="input"></input_>
            </div>
        </div>
    </div>

</template>

<script>
    const jdenticon = require("jdenticon");
    import Vue from 'vue'
    import {getProfile} from '../../../data/profile';
    import {getMainComments} from "../../../data/comment";
    import ProfileSection from "./ProfileSection";
    import Carousel from '@/components/entity/Carousel'
    import Caption_ from '@/components/comments/Caption'
    import Comment from '@/components/comments/Comment'
    import Input_ from '@/components/comments/Input'
    // import Favorite from "./Favorite";
    import PhoneFavorite from "./PhoneFavorite";
    import {Entity, ShowEntityMode} from "../../../utils";

    export default {
        name: "Infoboard",
        components: {
            PhoneFavorite,
            ProfileSection,
            Carousel,
            Caption_,
            Comment,
            Input_
        },
        props: {
            e: Object,  // entity
            /* 设置 Infoboard 的高度，这个高度由 Carsousel 传入 */
            height: {
                type: Number
            },
            // 在 PC 尺寸下默认展示的宽度是 335，如果是 mobile，则与 Carsousel 图片等宽
            width: {
                type: Number,
                default: 335
            }
        },
        data() {
            return {
                infinite: true,
                isFirst: false,
                comments: [],
                // 给一个模拟的初始值实现预加载，避免页面留白
                profile: {
                    avatar: require('@/assets/transparent-gray_320x320.png'),  // 使用预加载图片
                    name: "...",
                    code: null
                },
                loadingComments: false
            }
        },
        created() {
            console.log('inforboard created()');
            // 如何绑定 ES6 export module 中的 this....... TODO refactor this into Profile component
            getProfile.bind(this)(this.e.profile_code).then((profile)=>{
                console.log(profile);
                if(this.$store.getters.getShowEntityMode() !== ShowEntityMode.PopupPageMode) // title 只在 single page 中显示，弹窗不显示的
                    this.$store.commit('setTitle', profile.name);
                this.profile = profile;
                console.log(`profile section created, fetched profile via profile code ${this.e.profile_code} is ${JSON.stringify(this.profile)}`);
            }).catch((error)=>{
                console.log(error);
            });

            // load comments TODO adding loading...
            // 1. load from cache TODO
            let mainComments = this.$store.getters.getComments(this.e.shortcode);
            if(mainComments !== undefined && mainComments !== null){
                this.comments = mainComments;
                console.log('comments loaded from cache:', this.comments);
            // 2. then load from remote.
            }else{
                this.loadingComments = true;
                getMainComments.bind(this)(this.e.shortcode).then((comments)=>{
                    this.comments = comments;
                }).catch((error)=>{
                    console.log(error);
                }).finally(()=>{
                    this.loadingComments = false;
                });
            }

        },
        computed: {
            // 资源的类别
            type: function(){
                return Entity.getType(this.e).name;
            },
            hasComments: function(){
                console.log(`hasComments, ${this.comments}`);
                return this.comments !== null && this.comments.length > 0 ? true: false;
            },
            // 因为 profile 是异步加载的，如果不设置这个标志位的话，profile section 初始的时候报错。
            // @deprecated 现在通过预加载（如果没有加载成功则使用空白模板显示）的方式提前显示，页面尽量不留白
            isProfileLoaded: function(){
                return this.profile !== null ? true: false;
            },
            isShowWatermark: function(){
                return this.$store.state.displayCtrl !== null ? this.$store.state.displayCtrl.watermark : false;
            }
        },
        methods: {
            /**
             * refactor this method into comment's components，之前想过，将 comment 的内容从 vuex 里面去获取，这样就可以把状态
             * 数据从 inforboard 中移除了！但是，这样做更不好的是，comment 组件居然必须和 vuex 耦合~ 这是更大的代价呀！
             * 因此，最终还是将评论的相关操作放到 infoboard 中来做，毕竟，我们需要把一些公共的方法放到顶层组装器中！
             * @param {Object} comment TODO 真实与服务器交互的时候，实际上只需要 comment text 即可。
             * @param {String|Number} tid, the comment thread id
             * @param {String|Number} rootid, the first level id
             */
            // updateComments(comment, tid = null, rootid = null){
            //     console.log('update comments:', comment, 'tid:', tid, 'rootid:', rootid);
            //     if(tid == null) {  // reply to the root
            //         this.comments.push(comment);
            //     }else { // reply to the target thread, if target tid is 2nd level then add its to the 1st level
            //         tid = tid.replace(/^comment-/, ''); // 去掉前缀
            //         var r = this.__findRootComponent(this.comments, rootid);
            //         if(r.threads == null){
            //             // r.threads = [];
            //             Vue.set(r, 'threads', new Array()); // 将新增属性 threads 纳入响应式管理！
            //         }
            //         r.threads.push(comment);
            //     }
            // }
        }
    }
</script>

<style scoped>

    :root {
        --height: 0px; /* 设置 infoboard 的总高度 */
        --width: 335px;  /* 设置 infoboard 的总宽度 */
    }

    /* 设置 el-card 的全局样式：消除 card 的圆角 */
    .el-card, .el-message {
        border-radius: 0px;
    }

    .infoboard{
        width: var(--width);
        height: var(--height);
    }

    .infoboard .body{
        padding: 15px;
        display: flex;
        flex-direction: column;
        background-color: white;
        transform: scale(1) rotate(0deg);
        /* 这个属性是关键，必须设置高度，否则 infoboard 内部超长部分的 div 不会自动隐藏，并且必须减去 padding 的高度，否则超长 */
        height: calc(var(--height) - 30px);
    }

    /* 自定义 divider 的 margin */
    .el-divider--horizontal{
        height: 1px;
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .iconfont{
        font-size: 16px;
    }

    /* 设置点击关注按键的样式，默认的 danger 的颜色太浅了，ed4956 是 instagram 的颜色 */
    /deep/ .el-button--danger{
        background-color: #ed4956;
        border-color: #ed4956;
    }

    /* 调整弹出窗口背景的透视程度，已经由 Carsousel 组件设置 */
    /*.el-image-viewer__mask {*/
    /*    opacity: 0.80;*/
    /*}*/

    /* 消除 el-card 默认的 1px gray border */
    .el-card {
        border: 0px;
    }

    .comment-panel {
        /*width:320px;*/
        position:relative;
        width: 100%;
        overflow: scroll;
    }

    .comment-panel .inner-block{
        /*width: 305px;*/
        width: 95%;
    }

</style>



// WEBPACK FOOTER //
// src/components/entity/infoboard/Infoboard.vue